import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://dhdbobyqevrzpxkisyya.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRoZGJvYnlxZXZyenB4a2lzeXlhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI2NTYzNTAsImV4cCI6MjA4ODIzMjM1MH0.yCX3P6Y5X6d2w26Eu6XmANEKWU2C498bTooG-zF9hyE';

export const supabase = createClient(supabaseUrl, supabaseKey);